// Barba
import barba from '@barba/core';

//Imports
import { normalizer, smoother, smootherPause } from './smoother';
import { navToggle } from './navbar';
import { colorChange, overlayColor } from './color';
import { enterTransition } from './animations/enterTransition';
import { leaveTransition } from './animations/leaveTransition';
import { showContent } from './animations/showContent';
import { hoverAnimation, linkChange } from './animations/linkAnimation';
import { canvasAnimation } from './animations/canvasAnimation';
import { cursor, cursorHover } from './cursor';
import { textWithimg, textWithImgAndHeading } from './text-with-img';
import { btnDesign } from './btnDesign';
import { removeVideo, videoWithPopup } from './video-with-popup';
import { slideShowWithContent } from './slideShowWithContent';
import { introAnimate, leadspaceHome, resetTransform } from './leadspace-home';
import { animateShow, logoShow, show } from "./animations/show";
import { contact } from './contact';
import { foodBowlSlider } from './food-bowl-slider';
import { parallax } from './animations/parallax';
import { heightFix } from './height-fix';
import { imgSliderWithText } from './img-slider-with-text';
import { imgWithTextCard } from './img-with-text-card';
import { scaleUp } from './animations/scaleUp';
import { leadspaceWithSliderAndText } from './leadspace-with-slider-and-text';
import { marqueeSlider } from './animations/marqueeSlider';
import { moveUp } from './animations/move-up';
import { introFork, initFork, setFork } from './animations/forkAnimation';
import { hide } from './animations/hide';
import { lazyLoad } from './lazyloading';

const barbaInit = () => {
    const body = document.querySelector('body');

    const globalFunc = () => {
        normalizer(true);
        heightFix();
        smoother();
        colorChange();
        hoverAnimation();
        linkChange();
        cursorHover();
        btnDesign();
        contact();
        initFork();
        lazyLoad();
    }

    const indexFunc = () => {
        introAnimate();
        leadspaceHome();
        textWithimg();
        videoWithPopup();
        slideShowWithContent(document.querySelectorAll('.slide-show-with-content figure'));
    }

    const careerFunc = () => {
        slideShowWithContent(document.querySelectorAll('.slide-show-with-content figure'));
    }

    const errorFunc = () => {
        canvasAnimation();
    }

    const productFunc = () => {
        parallax('product');
        textWithimg();
        foodBowlSlider();
        imgSliderWithText();
        imgWithTextCard();
        scaleUp('.text-with-large-img', '.text-with-large-img__figure');
    }

    const aboutFunc = () => {
        parallax('about');
        leadspaceWithSliderAndText();
        imgSliderWithText();
        marqueeSlider('.marquee-img-slider-with-heading', '.marquee-img-slider-with-heading__swiper');
        textWithImgAndHeading();
    }

    const impactFunc = () => {
        parallax('impact');
        imgWithTextCard();
        moveUp('.text-with-stat-and-img__left-content', true);
        scaleUp('.text-with-stat-and-img', '.text-with-stat-and-img__figure');
    }

    const termsFunc = () => {
        parallax('terms');
    }

    barba.init({
        preventRunning: true,
        transitions: [
            {
                enter: () => enterTransition(),
                afterEnter: () => leaveTransition(),
            },
            {
                to: {
                    namespace: 'index'
                },
                once: () => {
                    window.cleanup = indexFunc();
                }
            },
            {
                to: {
                    namespace: 'about'
                },
                once: () => {
                    window.cleanup = aboutFunc();
                }
            },
            {
                to: {
                    namespace: 'careers'
                },
                once: () => {
                    window.cleanup = careerFunc();
                }
            },
            {
                to: {
                    namespace: 'error'
                },
                once: () => {
                    window.cleanup = errorFunc();
                }
            },
            {
                to: {
                    namespace: 'product'
                },
                once: () => {
                    window.cleanup = productFunc();
                }
            },
            {
                to: {
                    namespace: 'impact'
                },
                once: () => {
                    window.cleanup = impactFunc();
                }
            },

            {
                to: {
                    namespace: 'terms'
                },
                once: () => {
                    window.cleanup = termsFunc();
                }
            }
        ]
    })

    barba.hooks.once((data) => {
        globalFunc();
        cursor();
        navToggle();
        data.next.namespace != 'index' ? showContent() : '';
        data.next.namespace == 'index' ? introFork() : setFork();
        data.next.namespace == 'careers' || data.next.namespace == 'error' ? hide('.bottom-bar') : show('.bottom-bar');
    })

    barba.hooks.beforeEnter(() => {
        smootherPause(true)
    })

    barba.hooks.enter(data => {
        overlayColor();
        logoShow(data.current.namespace);
        data.next.namespace != 'index' ? setFork() : '';
        data.next.namespace == 'careers' ? hide('.bottom-bar') : show('.bottom-bar');
    })

    barba.hooks.afterEnter(data => {
        body.classList.remove('navbar__offcanvas--active');
        body.classList.remove('contact-modal--active');
        window.scrollTo(0,0);
        data.next.namespace == 'index' ? resetTransform() : '';
    })

    barba.hooks.after((data) => {
        globalFunc();
        removeVideo();
        data.next.namespace == 'index' ? window.cleanup = indexFunc() : '';
        data.next.namespace == 'careers' ? window.cleanup = careerFunc() : '';
        data.next.namespace == 'about' ? window.cleanup = aboutFunc() : '';
        data.next.namespace == 'product' ? window.cleanup = productFunc() : '';
        data.next.namespace == 'impact' ? window.cleanup = impactFunc() : '';
        data.next.namespace == 'error' ? window.cleanup = errorFunc() : '';
        data.next.namespace == 'terms' ? window.cleanup = termsFunc() : '';
        data.next.namespace != 'index' ? animateShow('.navbar__logo') : '';
    })
}

const init = () => {
    barbaInit();
}

init();
